import React, {useEffect} from 'react'

import { useSelector, useDispatch } from 'react-redux'

// Components

import SectionHeading from '../../../../UI/SectionHeading/SectionHeading';
import TextInput from '../../../../UI/FormInput/TextInput';
import DropDownInput from '../../../../UI/FormInput/DropDownInput';
import MaskInput from '../../../../UI/FormInput/MaskInput';
import FormInputGroup from '../../../../UI/FormInputGroup/FormInputGroup';
import Button from '../../../../UI/Button/Button';

// Hooks

import GetPhoneAreaCodesByState from '../../../../../hooks/GetPhoneAreaCodesByState';

// Utilities

import { formatDropDownOptions, formatDropDownOptionsAlt, formatDropDownOptionsWithValueAsName } from '../../../../../utilities/helper-functions';

// Constants

import { PHONE_MASK_FORMAT, PHONE_AREA_CODE_MASK_FORMAT, INTERNATIONAL_FULL_PHONE_MASK_FORMAT } from '../../../../../config/constants';

export default function ContactInfo({formik, formStep, setFormStep}) {
    const { getPhoneAreaCodesIsLoading, getPhoneAreaCodesError, phoneAreaCodes, handleGetPhoneAreaCodesByState } = GetPhoneAreaCodesByState();
    // Dropdown Options
    const dropDownOptions = useSelector((state) => state.options.dropDownOptions);
    const dispatch = useDispatch();

    // Get Phone Area Codes by State

    useEffect(() => {
        if (formik.values?.direccion?.entidad) {
            handleGetPhoneAreaCodesByState(formik.values?.direccion?.entidad);
        }
    }, [formik.values?.direccion?.entidad])

    return (
    <>
        <SectionHeading text={'Introduce tus datos de contacto, porque la vía más expedita es conectarnos vía digital o telefónica'} />

        <FormInputGroup>
        
            <TextInput
                formik={formik}
                fieldName={'cliente.mail'}
                label={'Correo electrónico'}
                maxLength={50}
                isRequired={true}
                disabled
            />
        
        </FormInputGroup>

        <SectionHeading isSubHeading text={'Teléfono 1'} />

        <div className='form-field-phone-group'>

            <DropDownInput
                formik={formik}
                fieldName={'direccion.telefono1.tipo'}
                label={'Tipo de Teléfono'}
                options={formatDropDownOptions(dropDownOptions?.data?.phoneTypes)}
                isRequired={true}
                disabled={true}
            />


            {formik.values?.direccion?.pais !== '0' &&
            <MaskInput
                formik={formik}
                fieldName={'direccion.telefono1.codigoArea'}
                label={'Código País y/o Área'}
                mask={PHONE_AREA_CODE_MASK_FORMAT}
                isRequired={true}
            />}

            {formik.values?.direccion?.pais === '0' &&
            <DropDownInput
                formik={formik}
                fieldName={'direccion.telefono1.codigoArea'}
                label={'Código País y/o Área'}
                options={formatDropDownOptionsWithValueAsName(dropDownOptions?.data?.phoneCodes)}
                // options={formik.values?.direccion?.telefono1?.tipo === 'T' ? formatDropDownOptionsAlt(phoneAreaCodes) : formatDropDownOptionsWithValueAsName(dropDownOptions?.data?.phoneCodes)}
                isRequired={true}
                // disabled={phoneAreaCodes?.length === 0 || getPhoneAreaCodesIsLoading || getPhoneAreaCodesError}
                loading={getPhoneAreaCodesIsLoading}
            />}

            <MaskInput
                formik={formik}
                fieldName={'direccion.telefono1.numero'}
                label={'Número de teléfono'}
                mask={formik.values?.direccion?.pais === '0' ? PHONE_MASK_FORMAT : INTERNATIONAL_FULL_PHONE_MASK_FORMAT}
                isRequired={true}
            />

        </div>

        <SectionHeading isSubHeading text={'Teléfono 2'} />

        <div className='form-field-phone-group'>

            <DropDownInput
                formik={formik}
                fieldName={'direccion.telefono2.tipo'}
                label={'Tipo de Teléfono'}
                options={formatDropDownOptions(dropDownOptions?.data?.phoneTypes)}
                showClear
            />

            {formik.values?.direccion?.pais !== '0' &&
            <MaskInput
                formik={formik}
                fieldName={'direccion.telefono2.codigoArea'}
                label={'Código País y/o Área'}
                mask={PHONE_AREA_CODE_MASK_FORMAT}
            />}

            {formik.values?.direccion?.pais === '0' &&
            <DropDownInput
                formik={formik}
                fieldName={'direccion.telefono2.codigoArea'}
                label={'Código País y/o Área'}
                options={formik.values?.direccion?.telefono2?.tipo === 'T' ? formatDropDownOptionsAlt(phoneAreaCodes) : formatDropDownOptionsWithValueAsName(dropDownOptions?.data?.phoneCodes)}
                disabled={phoneAreaCodes?.length === 0 || getPhoneAreaCodesIsLoading || getPhoneAreaCodesError}
                loading={getPhoneAreaCodesIsLoading}
                showClear
            />}

            <MaskInput
                formik={formik}
                fieldName={'direccion.telefono2.numero'}
                label={'Número de teléfono'}
                mask={formik.values?.direccion?.pais === '0' ? PHONE_MASK_FORMAT : INTERNATIONAL_FULL_PHONE_MASK_FORMAT}
            />

        </div>
            
        <div className='form-actions'>

            <Button
                action={() => dispatch(setFormStep(formStep - 1))}
                label={'Regresa'}
                secondaryStyle={true}
            />

            <Button
                type="button"
                action={formik.handleSubmit}
                label={'Continua'}
            />

        </div>
    </>
  )
}
